import api from './api';

export const websiteApi = {
  // Get all websites with pagination and filters
  getAll: async (params?: {
    page?: number;
    limit?: number;
    sslStatus?: boolean;
    hasDirLinks?: boolean;
    isGenerated?: boolean;
    isActive?: boolean;
    search?: string;
  }): Promise<{ data: any[]; total: number; page: number; limit: number; totalPages: number }> => {
    const queryParams: any = {};
    if (params?.page) queryParams.page = params.page.toString();
    if (params?.limit) queryParams.limit = params.limit.toString();
    if (params?.sslStatus !== undefined) queryParams.sslStatus = params.sslStatus.toString();
    if (params?.hasDirLinks !== undefined) queryParams.hasDirLinks = params.hasDirLinks.toString();
    if (params?.isGenerated !== undefined) queryParams.isGenerated = params.isGenerated.toString();
    if (params?.isActive !== undefined) queryParams.isActive = params.isActive.toString();
    if (params?.search) queryParams.search = params.search;
    
    const response = await api.get('/websites', { params: queryParams });
    return response.data;
  },

  // Get website by ID
  getById: async (id: string) => {
    const response = await api.get(`/websites/${id}`);
    return response.data;
  },

  // Create website
  create: async (websiteData: any) => {
    const response = await api.post('/websites', websiteData);
    return response.data;
  },

  // Update website
  update: async (id: string, websiteData: any) => {
    const response = await api.patch(`/websites/${id}`, websiteData);
    return response.data;
  },

  // Delete website
  delete: async (id: string) => {
    const response = await api.delete(`/websites/${id}`);
    return response.data;
  },

  // Get website sections
  getWebsiteSections: async (id: string) => {
    const response = await api.get(`/websites/${id}/web-builder/sections`);
    return response.data;
  },

  // Add new section
  addWebsiteSection: async (id: string, sectionData: any) => {
    try {
      const response = await api.post(`/websites/${id}/web-builder/sections`, sectionData);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  // Update section
  updateWebsiteSection: async (id: string, sectionId: string, sectionData: any) => {
    const response = await api.patch(`/websites/${id}/web-builder/sections/${sectionId}`, sectionData);
    return response.data;
  },

  // Delete section
  deleteWebsiteSection: async (id: string, sectionId: string) => {
    const response = await api.delete(`/websites/${id}/web-builder/sections/${sectionId}`);
    return response.data;
  },

  // Reorder sections
  reorderWebsiteSections: async (id: string, sectionIds: string[]) => {
    const response = await api.patch(`/websites/${id}/web-builder/sections/reorder`, { sectionIds });
    return response.data;
  },

  // Regenerate website
  regenerateWebsite: async (id: string) => {
    const response = await api.post(`/website-generator/regenerate/${id}`);
    return response.data;
  },

  // Update website config
  updateConfig: async (id: string, configData: any) => {
    const response = await api.patch(`/websites/${id}/config`, configData);
    return response.data;
  },

  // Get file content
  getFileContent: async (id: string, filePath: string) => {
    const response = await api.get(`/websites/${id}/files/content`, {
      params: { filePath },
    });
    return response.data.content;
  },
};